/*-----------------------------------------------------------------
- General translations
-----------------------------------------------------------------*/

export default {
    layout: {
        title      : 'عنوان الموقع',
        separator  : '::',
        description: 'كوارك :: قوي من كواركينو',
    },

    404: {
        title       : 'الصفحة غير موجودة.',
        back_to_home: 'اذهب الى المنزل',
    },

    schedule_demo            : 'جدولة العرض',
    request_demo             : 'طلب عرض',
    schedule_demo_modal_title: 'بناء على ما هو أبعد من توقعاتك',

    header: {
        log_in     : 'دخول',
        client_area: 'منطقة العملاء',
        schedule   : 'جدولة العرض',
    },

    footer: {
        find_us_on              : 'تجدنا على',
        newsletter_section_title: 'النشرة الإخبارية',
        newsletter_button       : 'يشترك',
        placeholder             : 'بريدك الالكتروني',
        success_msg             : 'تم إرسال البريد الإلكتروني الخاص بك بنجاح.',
        error_msg               : 'حدثت مشكلة ، يرجى المحاولة مرة أخرى.',
    },
};
